module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-wrapper"
  }, [_c('second-header'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('main-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "main-inner"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "content",
    staticStyle: {
      "background": "#fff",
      "padding": "2em",
      "border-radius": "5px",
      "border": "1px solid #666"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: " col-lg-12 ccol-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "page-title"
  }, [_c('h2', {
    staticStyle: {
      "font-weight": "500",
      "color": "#22baae"
    }
  }, [_vm._v("How You Can Find And Contract A CNpro ")])]), _vm._v(" "), _c('div', [_c('div', {
    attrs: {
      "id": "premuim"
    }
  }, [_c('h3', [_vm._v("OPTION 1")]), _vm._v(" "), _c('h4', [_vm._v("HELP ME FIND A CNpro.")]), _vm._v(" "), _c('p', [_vm._v("Click \"Help Me Find A CNpro\" at the top, a form will drop down.\r\n\t\t\t\t\t\t\t\t\t\tFill the form, send, and we will help you find the ideal CNpro (pro skilled-worker).\r\n\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('h3', [_vm._v("OPTION 2")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("Step 1")]), _vm._v(" "), _c('h4', [_vm._v("MAKE A CHOICE")]), _vm._v(" "), _c('p', [_vm._v("Search for your proposed job category.")]), _vm._v(" "), _c('p', [_vm._v("Choose from a pool of listed Service Professionals (CNpros) that match the job")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("Step 2.")]), _vm._v(" "), _c('h4', [_vm._v("CHOOSE A PLAN")]), _vm._v(" "), _c('p', [_vm._v("Subscribe to any of the "), _c('a', {
    staticStyle: {
      "color": "inherit"
    },
    attrs: {
      "href": "how-it-works"
    }
  }, [_c('b', [_vm._v("Plans")])]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("Step 3.")]), _vm._v(" "), _c('h4', [_vm._v("GETTING THE JOB DONE")]), _vm._v(" "), _c('p', [_vm._v("Start chatting with your chosen CNpro, or call the CNpro's listed phone number, and describe your proposed job.")]), _vm._v(" "), _c('p', [_vm._v("CNpro meets with You and evaluates the job.")]), _vm._v(" "), _c('p', [_vm._v("CNpro sends You a Job Quote, and CNpro's Fees (Labour Charge) for the proposed job.")]), _vm._v(" "), _c('p', [_vm._v("You purchase/provide the work materials for the proposed job.")]), _vm._v(" "), _c('p', [_vm._v("Your payment card is securely "), _c('b', [_vm._v("( 256-bit SSL encryption)")]), _vm._v(" debited for CNpro's Fees (Labour Charge) upfront, and payment is kept in escrow.")]), _vm._v(" "), _c('p', [_vm._v("On satisfactory completion of job by CNpro, You sign-off and notify Cityneeds")]), _vm._v(" "), _c('p', [_vm._v("After a Job-Quality-Monitoring period of 48 hours (2 days), if no complaint is received from You, CNpro's Fees (Labour Charge) is released and paid to the CNpro.")])]), _vm._v(" "), _c('br'), _c('br'), _c('br')])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ffa01de"}!./src/components/HowItWorks/template.html
// module id = 274
// module chunks = 0